import React from 'react';
import PropTypes from 'prop-types';

function DisplayError({ errorStore }) {
    const {
        error,
        rootStore
    } = errorStore;

    const backLink = <button className='btn btn--base btn--primary'
                             onClick={() => rootStore.routerStore.goTo('master.app.main.dashboard')}>GO TO DASHBOARD</button>;
    return (
        <React.Fragment>
            <section>
                <div className='login__top'>
                    <img className='login__top__logo' src={require('themes/assets/img/logo.svg')} alt='Logo' />
                </div>
                <div className='container--login'>
                    <form className='form card card--lrg card--primary type--center'>
                        <h1 className='u-mar--bottom--med type--wgt--bold type--color--primary'>Oops!</h1>
                        <img className="w--200--px u-mar--bottom--med" src={require('themes/assets/img/schedule.svg')} alt='Error'/>
                        <div className='u-mar--bottom--med'>
                            {error ? (error.message || error.title) : 'Something went wrong. Please contact support.'}
                            {error && error.description && <span>{error.description}</span>}
                        </div>
                        <div>
                            {backLink}
                        </div>
                    
                    </form>
                </div>
            </section>
        </React.Fragment>
    );
}

DisplayError.propTypes = {
    errorStore: PropTypes.object
};

export default DisplayError;
